// extracted by mini-css-extract-plugin
export default {"wrapper":"stumbleGuysAlternative_wrapper__VFRAD","button":"stumbleGuysAlternative_button__hgRcr"};